import { render, staticRenderFns } from "./CleanerComparison.vue?vue&type=template&id=20e6483e"
import script from "./CleanerComparison.vue?vue&type=script&lang=js"
export * from "./CleanerComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports